import { z } from "zod"

export const trimmedString = () => z.string().trim()

export const requiredTrimmedString = (
  requiredMessage: string
) => trimmedString().min(1, requiredMessage)

export const emailAddressSchema = (
  requiredMessage: string
) =>
  requiredTrimmedString(requiredMessage).email(
    "Invalid email address"
  )
